export enum ThemeType {
  Default = 'infinity-theme',
  Pink = 'sweet-theme',
  Orange = 'pink-light-theme',
  Purple = 'provence-theme',
  Deep = 'deep-theme',
  Dark = 'devui-dark-theme',
  Custom = 'customize-theme',
}
